import { Component, Input, OnChanges, SimpleChanges, TemplateRef, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'split-hide-text',
  templateUrl: './split-hide-text.component.html',
  styleUrls: ['./split-hide-text.component.scss']
})
export class SplitHideTextComponent {

  isShow: boolean = true;
  @Input() hideButton: boolean = false;
  @Input() bind!: SplitHideTextComponent[];

  taggle() {
    this.isShow = !this.isShow;
    this.bind.map(bind => bind.isShow = this.isShow);
  }


}
